export interface GetUserRemindHistoriesRequest {
  id: string
}

export function GetUserRemindHistoriesRequestToJSON(
  value: GetUserRemindHistoriesRequest
): any {
  return {
    id: value.id !== '' ? value.id : undefined
  }
}
